import { StyledCashmanCasino } from './style';
import { BundleProps } from 'utils/types';
import { Box } from '@mui/system';
import { CashmanCasinoBundlePrice } from './BundlePrice';
import { generateSalePercentageBasedOnType } from 'utils';
import { EGradientDirection } from 'utils/enums';
import { useMemo } from 'react';
import { AutoTextSize } from 'utils/autoTextSizeUtils';
import { CashmanCasinoProduct } from './Components/Product';

const bgSaleBadge =
  'https://media.appcharge.com/media/shop-images/cashman-assets/sale-badge.png';

export const CashmanCasinoBundle: React.FC<BundleProps> = ({
  prices,
  productList,
  backgroundSrc,
  backgroundColor = {
    colorOne: '#406cf9',
    colorTwo: '#6449ff',
    gradientDirection: EGradientDirection.BottomToTop,
  },
  salePercentage = 0,
  salePercentageDisplayType,
  tooltipLoadCallback,
  tooltipOpenEventHandler,
}) => {
  const badgeText = useMemo(() => {
    if (!(salePercentage > 0)) return '';
    return (
      generateSalePercentageBasedOnType(
        salePercentage,
        salePercentageDisplayType,
      ) + ` MORE`
    );
  }, []);

  return (
    <StyledCashmanCasino
      productColor={
        productList.length > 0 ? productList[0].textFontColorHex : ''
      }
      backgroundSrc={backgroundSrc}
      backgroundColor={backgroundColor}
      className="cashman-bundle"
    >
      {badgeText && (
        <div className="cashman-bundle__sale-badge">
          <img
            src={bgSaleBadge}
            alt={'bg sale image'}
            style={{ width: '65%' }}
          />
          <div className="cashman-bundle__sale-badge__text">
            <AutoTextSize maxFontSizePx={12} minFontSizePx={6} mode="oneline">
              {badgeText}
            </AutoTextSize>
          </div>
        </div>
      )}
      <Box className={'cashman-bundle__products-container'}>
        {productList.map((product) => (
          <CashmanCasinoProduct
            product={product}
            tooltipLoadCallback={tooltipLoadCallback}
            tooltipOpenEventHandler={tooltipOpenEventHandler}
            salePercentage={salePercentage}
          />
        ))}
      </Box>
      <CashmanCasinoBundlePrice prices={prices} />
    </StyledCashmanCasino>
  );
};
